<h6 class="sub-heading">{{'_Data_Import_Logs_Label_Text_' | translate }}</h6>

<div class="logs-card">
    <ul class="log-msg-card">
        <li *ngIf="(logData$ | async)?.length == 0">{{'_Data_Import_No_Logs_To_Display_Message_Text_' | translate }}</li>
        <li *ngFor="let log of logData$ | async">
            <span>{{log.inputFileName}} - </span>
            <span [ngClass]="logClass(log)">{{log.message | translate }}</span>
        </li>
    </ul>
</div>